import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

function PreviousVersionPrimer(): JSX.Element {
  return (
    <form className="buffer-content-container form-horizontal">
      <fieldset>
        <legend>Design</legend>
        <p>
          Primer design is disabled on previous versions.{' '}
          <a href="#" className="js-switch-to-latest">
            Switch to the latest version.
          </a>
        </p>
      </fieldset>
    </form>
  );
}

export default makeDeprecatedJadeStyleTemplate(PreviousVersionPrimer);
